function MemberPurchaseModel($q, MemberPurchaseService, BBModel, BaseModel) {
    'ngInject';

    class Member_Purchase extends BaseModel {

        constructor(data) {
            super(data);

            this.created_at = moment.parseZone(this.created_at);
            if (this.time_zone) {
                this.created_at.tz(this.time_zone);
            }
        }

        getItems() {
            const deferred = $q.defer();
            this._data.$get('purchase_items').then(function (items) {
                this.items = Array.from(items).map(item =>
                    new BBModel.Member.PurchaseItem(item));
                return deferred.resolve(this.items);
            });
            return deferred.promise;
        }

        static $query(member, params) {
            return MemberPurchaseService.query(member, params);
        }
    }

    return Member_Purchase;
}

angular
    .module('BB')
    .service('Member.PurchaseModel', MemberPurchaseModel);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/_models/member_purchase_model.service.js